<template>
  <div class="p-3 flex justify-between items-center bg-key rounded-4xl">
    <div class="flex items-center gap-1 text-l-medium text-black-white h-9">
      <Icon icon="Writing-Wireframe-List " class="size-6" />
      <span>{{ $t('setting.about.notificationTitle') }}</span>
    </div>
    <Switch
      size="lg"
      :model-value="preference.notificationEnabled"
      @update:model-value="preference.notificationEnabled = $event"
    />
  </div>
</template>

<script lang="ts" setup>
  import { Icon, Switch } from '@rapoo/element'
  import { usePreferenceStore } from '@/stores/preference'
  const preference = usePreferenceStore()
</script>
